import { FC, useCallback, useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { Pagination } from "@douyinfe/semi-ui";
import cName from 'classnames';
export interface IPagination {
  className?: string,
  total: number,
  current: number,
  pageSize: number,
  onPageChange: (current: number) => void
}

export const Pagina: FC<IPagination> = ({
  className = '',
  total,
  current,
  pageSize,
  onPageChange = () => { }
}) => {

  return (
    <div className={cName(styles.pagination, className)}>
      <Pagination
        {
        ...{
          total: total,
          currentPage: current,
          pageSize,
          prevText: '',
          nextText: '',
          onPageChange
        } as any
        }
      >
      </Pagination>

      <style jsx global lang="scss">
        {
          `
            .semi-page{
              justify-content:center;
            }
            .semi-page-prev,
            .semi-page-next{
              margin: 0 10px !important;
              // padding: 10px 30px;
              font-size:14px !important;
              // color:#666 !important;
              width:auto !important;
            }
            .semi-page-item{
              height:40px;
              width:40px;
              font-size:16px;
              color: #333;
              // background:#eaf3ee;
              margin:0 5px;
            }
            .semi-page-item:hover{
              background-color:#efeef6;
            }
            .semi-page-item-active{
              color:white !important;
              background:#6354a2 !important;
              border:none !important;
            }
          `
        }
      </style>
    </div>
  );
};
